export default class ShiftLock {
  incodes: Array<number>;
  targetDate: string;
  constructor(incodes: Array<number>, targetDate: string) {
    this.incodes = incodes;
    this.targetDate = targetDate;
  }
}
